/**
 * @file 页面实例管理器
 * @author zhaolongfei
 */

import {Component} from '@src/lib/San';

export interface InstanceConfig {
    $root: HTMLElement;
    $scroller: HTMLElement;
    platform?: 'pc' | 'h5' | 'na' | 'pc_client';
    log: boolean | {
        ubcId: string;
        params: Record<string, unknown>;
        ext: Record<string, unknown>;
    };
    ui?: {
        timetag?: boolean;
        like?: boolean;
    };
    hostTag?: string;
    api?: {
        sse: string;
        sseParams: Record<string, unknown>;
        model?: string;
    };
    context?: string;
    watermask?: {
        text?: string;
        options?: Record<string, unknown>;
    };
}

interface Instance {
    config: InstanceConfig;
}

const APP = Symbol('app');
const INSTANCES = Symbol('instances');

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
// class SingletonEmitter {
//     static instance: EventEmitter | null = null;

//     static getInstance() {
//         if (!SingletonEmitter.instance) {
//             SingletonEmitter.instance = new EventEmitter();
//             SingletonEmitter.instance.setMaxListeners(Infinity);
//         }
//         return SingletonEmitter.instance;
//     }
// }

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class InstanceManager {
    private [APP]: Component | null = null;
    private [INSTANCES] = new Map<Component, Instance>();

    get store() {
        return this[APP]?.store;
    }

    get emitter() {
        return this[APP]?.emitter;
    }

    get config() {
        const defaultConfig = {
            $root: document.documentElement,
            $scroller: document.documentElement,
        } as InstanceConfig;
        return this[INSTANCES].get(this[APP] as Component)?.config || defaultConfig;
    }

    create(app: Component, instance: Instance) {
        const {config} = instance;
        if (!config.$scroller) {
            config.$scroller = document.documentElement;
        }
        this[APP] = app;
        this[INSTANCES].set(app, instance);
    }

    active(app: Component) {
        if (!this[INSTANCES].has(app)) {
            throw new Error('InstanceManager: container not exist');
        }
        this[APP] = app;
    }

    clear(app: Component) {
        if (!app) {
            this[INSTANCES].clear();
        }
        else if (this[INSTANCES].has(app)) {
            app.emitter?.removeAllListeners();
            app.store?.clear();
            this[INSTANCES].delete(app);
        }
        else {
            throw new Error('InstanceManager: container not exist');
        }
    }
}

const __INSTANCE__ = new InstanceManager();

export default __INSTANCE__;
